import { useCopilot } from '../../api/copilot';
import { callSafely } from './util';

/**
 * Voice replies: when you speak, always, or never.
 *
 * `auto` is the default because a desk full of people typing does not want the
 * app talking back, while someone who just spoke a question expects to hear the
 * answer. The label says the current mode in words, since three speaker glyphs
 * are not self-explanatory, and what a press will change it to.
 */
const MODES = {
  auto: { label: 'Voice replies: when you speak', next: 'on' },
  on: { label: 'Voice replies: always', next: 'off' },
  off: { label: 'Voice replies: off', next: 'auto' },
};

const NEXT_WORD = { auto: 'when you speak', on: 'always', off: 'off' };

function Glyph({ mode }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
      {mode === 'on' && <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />}
      {mode === 'auto' && <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />}
      {mode === 'off' && <path d="M23 9l-6 6M17 9l6 6" />}
    </svg>
  );
}

export default function SpeakerToggle() {
  const { speaker = 'auto', cycleSpeaker, unlockAudio } = useCopilot();
  const mode = MODES[speaker] ? speaker : 'auto';
  const { label, next } = MODES[mode];

  return (
    <button
      type="button"
      className={`cp-speaker m-${mode}`}
      title={`${label} — press for ${NEXT_WORD[next]}`}
      aria-label={`${label}. Press to change to ${NEXT_WORD[next]}.`}
      onClick={() => {
        /* Switching voice on is a user gesture, which is exactly what the
           browser needs before it lets the agent's audio play. */
        if (next !== 'off') callSafely(unlockAudio);
        callSafely(cycleSpeaker);
      }}
    >
      <Glyph mode={mode} />
    </button>
  );
}
